<template>
  <header>
    <b-navbar
      spaced
      shadow
      class="bg-gray shadow"
    >
      <template
        slot="brand"
        class="text-center"
      >
        <a
          class="mr-8"
          href="https://www.uniformatic.fr/"
        >
          <img
            class="is-desktop m-auto"
            width="105px"
            src="../assets/logo.png"
            alt="Panneau de configuration de baies de brassage en ligne"
          >
          Retour au site
        </a>
        <img
          class="mr-8 logo"
          :src="require(`@/assets/${getLogo}.png`)"
        >
      </template>

      <template slot="start">
        <b-navbar-dropdown label="Choix du configurateur">
          <b-navbar-item
            tag="router-link"
            to="/uni-baies"
          >
            Uni|Baies
          </b-navbar-item>
          <b-navbar-item
            tag="router-link"
            to="/uni-trunk/configuration"
          >
            Uni|Trunk
          </b-navbar-item>
        </b-navbar-dropdown>
      </template>
      <template slot="end">
        <b-navbar-item tag="div">
          <p class="has-text-weight-bold text-primary text-center mr-4">
            Besoin d’informations ?
            <br>
            TEL : 01 58 02 06 10
          </p>
          <div class="ml-4 buttons">
            <router-link
              v-if="!connected"
              to="/inscription"
              class="button is-primary"
            >
              <strong>Créer un compte</strong>
            </router-link>
            <router-link
              v-if="!connected"
              :to="`/connexion?redirect=${$router.currentRoute.path}`"
              class="button is-info"
            >
              <strong>
                Se connecter
              </strong>
            </router-link>
            <b-button
              v-else
              type="is-danger"
              outlined
              @click="$emit('signOut')"
            >
              Se déconnecter
            </b-button>
          </div>
        </b-navbar-item>
      </template>
    </b-navbar>
  </header>
</template>

<script>
export default {
  name: 'TheNavbar',
  props: {
    connected: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getConfigurateur() {
      let configurateur = 'Uni|Baies';
      if (this.$route.path.includes('trunk')) {
        configurateur = 'Uni|Trunk';
      }
      return configurateur;
    },
    getLogo() {
      let logo = 'logo_uni_baies';
      if (this.getConfigurateur === 'Uni|Trunk') {
        logo = 'logo_uni_trunk';
      }
      return logo;
    },
  },
};
</script>

<style scoped>
.image-height {
  height: 54px;
}

.logo {
  height: 80px;
}
</style>
